import { render, staticRenderFns } from "./SkillPrivacyModal.vue?vue&type=template&id=366004e6&"
import script from "./SkillPrivacyModal.vue?vue&type=script&lang=js&"
export * from "./SkillPrivacyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports